import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { symantecEDRThrottleEnabled, disableTLSCheck } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "symantecEDRThrottleEnabled",
        defaultChecked: symantecEDRThrottleEnabled == null ? void 0 : symantecEDRThrottleEnabled.value,
        onChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "disableTLSCheck",
        type: "checkbox",
        value: "disable-tlsCheck",
        defaultChecked: disableTLSCheck == null ? void 0 : disableTLSCheck.value,
        onChange,
        label: t("symantecedr.advanced_options.disable_tls_validation"),
        help: t("symantecedr.advanced_options.disable_tls_validation_help")
      }
    )
  );
};
export default FormAdvancedOptions;
